// convert a url to relative
export const relativeUrl = url => `/${url.replace(/^(?:\/\/|[^\/]+)*\//, '')}`

export const removeProtocol = (url, pretty = false) => `${pretty ? '' : '//'}${url.replace(/.*?:\/\//g, '')}`

export const addProtocol = (url, type = 'http') => (url.match(/^(http|https):\/\//) ? url : `${type}://${url}`)

export default {
    relativeUrl,
    removeProtocol,
    addProtocol,
}



// WEBPACK FOOTER //
// ./js/shared/util/url.js